import './InsightsPanel.css';
import UsageTab from './UsageTab';
import ResponseTab from './ResponseTab';
import HistoryTab from './HistoryTab';

const INSIGHTS_TABS = [
    { key: 'usage', label: 'Usage' },
    { key: 'response', label: 'Response' },
    { key: 'history', label: 'History' },
];

function InsightsPanel({ tab, onTab, side, onClose, entry, entries, session, existingBlockIds, busy, copiedKey, onCopy, onGoToBlock, onSelect, onViewResponse, onResume, onReplay, onRemoveBlocks, onDeleteEntry, onClearHistory }) {
    return (
        <div className={'ai_chat_panel_stats_panel side-' + side}>
            <div className="ai_chat_panel_stats_panel_header">
                <span>Teia insights</span>
                <i className="fas fa-times" title="Close" onClick={onClose}></i>
            </div>
            <div className="ai_chat_panel_tabs">
                {INSIGHTS_TABS.map(({ key, label }) =>
                    <button key={key} type="button" className={'ai_chat_panel_tab' + (tab === key ? ' active' : '')} onClick={() => onTab(key)}>
                        {label}{key === 'history' && entries.length > 0 ? ' (' + entries.length + ')' : ''}
                    </button>
                )}
            </div>
            <div className="ai_chat_panel_stats_panel_body">
                {tab === 'usage' && <UsageTab entry={entry} session={session} />}
                {tab === 'response' && <ResponseTab entry={entry} existingBlockIds={existingBlockIds} copiedKey={copiedKey} onCopy={onCopy} onGoToBlock={onGoToBlock} />}
                {tab === 'history' &&
                    <HistoryTab
                        entries={entries}
                        selectedId={entry ? entry.id : null}
                        existingBlockIds={existingBlockIds}
                        busy={busy}
                        onSelect={onSelect}
                        onViewResponse={onViewResponse}
                        onResume={onResume}
                        onReplay={onReplay}
                        onRemoveBlocks={onRemoveBlocks}
                        onDeleteEntry={onDeleteEntry}
                        onClearHistory={onClearHistory}
                    />
                }
            </div>
        </div>
    );
}

export default InsightsPanel;
